import { config } from '@common/config';
import { BadRequestError } from '@services/BaseService';
export enum CILNotificationSelection {
  CashInLieu = 1,
  Replacement = 2
}

export interface CILNotificationViewModel {
  Appliance_Description?: string;
  Appliance_Type?: string;
  Cash_In_Lieu_Am?: string;
  CIL_Only_Fl?: boolean;
  CIL_Only_Reason_Ds?: string;
  Contract_Address1?: string;
  Contract_Address2?: string;
  Contract_City?: string;
  Contract_Num?: string;
  Contract_State?: string;
  Contract_Zip?: string;
  Customer_Nm?: string;
  Est_Delivery_Dt?: string;
  Product_SKU?: string;
  Service_Request_Num?: string;
  Supplier_Nm?: string;
  Supplier_Product_URL?: string;
  Supplier_Store_Num?: string;
}

/**
 * Service to interact with API built by FNHW to provide access to CIL information.
 * This service does not inherit from BaseService for the following reasons:
 *   1) CIL API (and associated pages in this site) use an alternate authentication mechanism
 *   2) CIL API issues non-standard HTTP status codes and must be interpreted differently
 */
class CILNotificationService {
  private readonly authorizationHeader: string;
  private readonly baseUri: string;

  constructor(baseUri: string, username: string, password: string) {
    if (baseUri.lastIndexOf('/') === baseUri.length - 1) {
      baseUri = baseUri.substr(0, baseUri.length - 1);
    }
    this.baseUri = baseUri;

    let credentials = `${username}:${password}`;
    this.authorizationHeader = `Basic ${btoa(credentials)}`;
  }

  public async getCILViewModel(
    swoTrackingCILOfferId: number,
    contractId: number,
    key: string
  ): Promise<CILNotificationViewModel> {
    const queryString = `id=${btoa(swoTrackingCILOfferId.toString())}&contractnum=${btoa(
      contractId.toString()
    )}&key=${key}`;
    const relativeUri = `api/purchasing?${queryString}`;
    const uri = this.baseUri.concat('/', relativeUri);
    const response: Response = await fetch(uri, {
      headers: {
        authorization: this.authorizationHeader
      },
      method: 'GET'
    });
    if (response.status === 400) {
      throw new BadRequestError(await response.json());
    }
    if (!response.ok) {
      throw new Error(
        `Encountered error communicating with CIL API, status code: "${
          response.status
        }", body: "${await response.json()}".`
      );
    }

    return (await response.json()) as CILNotificationViewModel;
  }

  public async postCILNotificationSelection(
    swoTrackingCILOfferId: number,
    selection: CILNotificationSelection,
    key: string
  ): Promise<void> {
    const queryString = `id=${btoa(swoTrackingCILOfferId.toString())}&Action=${selection}&key=${key}`;
    const relativeUri = `api/purchasing?${queryString}`;
    const uri = this.baseUri.concat('/', relativeUri);
    const response: Response = await fetch(uri, {
      headers: {
        authorization: this.authorizationHeader
      },
      method: 'POST'
    });
    if (!response.ok) {
      throw new Error(
        `Encountered error communicating with CIL API, status code: "${
          response.status
        }", body: "${await response.json()}".`
      );
    }
  }
}

export const cilNotificationService = new CILNotificationService(
  config.cilApiBaseURI,
  config.cilApiUserName,
  config.cilApiPassword
);



// WEBPACK FOOTER //
// ./src/_services/CILNotificationService.ts